import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';

const DigitalPayment = loadable(() => import('./DigitalPayment'), {
    fallback: null,
});

// const DigitalPaymentFormSummary = loadable(() => import('./DigitalPaymentFormSummary'), {
//     fallback: null,
// });

const DigitalPaymentComplete = loadable(() => import('./DigitalPaymentComplete'), {
    fallback: null,
});

const NotFound = loadable(() => import('../NotFound'), {
    fallback: null,
});

export default function DigitalPaymentRoute() {
    return (
        <Routes>
            <Route path="/" element={<DigitalPayment />} />
            {/* <Route
                path="form-summary/:policyNo"
                element={<DigitalPaymentFormSummary />}
            /> */}
            <Route path="complete" element={<DigitalPaymentComplete />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
